<ng-sidebar-container style="height: 30vh">
  <ng-sidebar
    class="my-sidebar"
    [(opened)]="_opened"
    [mode]="_MODES[0]"
    [position]="_POSITIONS[1]"
    [dock]="'false'"
    [dockedSize]="'0'"
    [sidebarClass]="'order-sidebar'"
    [ariaLabel]="'My sidebar'"
  >
    <p>Sidebar</p>
    <button class="btn pizza-btn" (click)="_toggleOpened()">
      Close sidebar
    </button>
    <hr />
    <p>Order item</p>
    <p>Order item</p>
    <p>Order item</p>
  </ng-sidebar>
  <div ng-sidebar-content>
    <section class="sidebar-contents">
      <h2>Sidebar</h2>
      <button class="btn pizza-btn" (click)="_toggleOpened()">
        opened ({{ _opened }})
      </button>
    </section>
  </div>
</ng-sidebar-container>
